import React from 'react';

/**
 * Shared CreateCollect brand lockup: "CC" monogram tile + wordmark.
 * Two color variants:
 *   - expressive (default): Riso Blue tile with paper "CC", used on marketing/onboarding surfaces
 *   - restrained: ink tile with paper "CC", used on money artifacts / trust-critical surfaces
 * Copy the exact classes from the inline monograms in Landing.js and PublicInvoice.js
 * so the new shared component is pixel-identical to the two already-approved implementations.
 */
const Logo = ({
  variant = 'expressive',
  showWordmark = true,
  size = 'md', // 'sm' | 'md'
  className = '',
  wordmarkClassName = '',
}) => {
  const isRestrained = variant === 'restrained';
  const isSm = size === 'sm';

  const tileClasses = isSm
    ? 'w-7 h-7 rounded-md text-[11px]'
    : 'w-9 h-9 rounded-md text-lg';

  const colorClasses = isRestrained
    ? 'bg-foreground text-background'
    : 'bg-primary text-primary-foreground';

  const wordmarkSize = isSm ? 'text-base' : 'text-xl';

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span
        aria-hidden="true"
        className={`inline-flex items-center justify-center font-heading font-bold tracking-tight ${tileClasses} ${colorClasses}`}
      >
        CC
      </span>
      {showWordmark && (
        <span className={`font-heading font-semibold tracking-tight ${wordmarkSize} ${wordmarkClassName}`}>
          CreateCollect
        </span>
      )}
    </span>
  );
};

export default Logo;
